import React, { Component } from 'react'
import { getImgPath } from "../common/helper";
export class headerSTA extends Component {
    render() {
        return (
            <div>
                <header id="header" className ="site-header inner-header header-style-1" style={{position:'relative'}}>
                <nav className="navigation navbar navbar-default">
                    <div className="container-fluid" >
                        <div className="navbar-header">
                            <button type="button" className="open-btn">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            </button>
                            <a className="navbar-brand" href="/">
                              <img src={window.awsImagePath + window.Searchlogo} alt="" />
                            </a> 
                        </div>
                        <div id="navbar" className="navbar-collapse collapse navigation-holder">
                            <button className="close-navbar"><i className="ti-close"></i></button>
                            <ul className="nav navbar-nav">
                                <li className="menu-item-has-children">
                                    <a href="/">Bus Booking</a>
                                    <ul className="sub-menu">
                                        <li><a href="/ticket/mybooking">View Booking</a></li>
                                        <li><a href="/ticket/mybooking/editbooking">Edit Booking</a></li>
                                        <li><a href="/ticket/cancel">Cancel</a></li>
                                    </ul>
                                </li>
                                <li><a href="/tourism">Tourism</a></li>
                                <li><a href="/cargoStatic">Cargo</a></li>
                                <li><a href="/contact_us">Help</a></li>
                            </ul>
                        </div>
                        <div className="search-contact">
                            <div className="header-search-area">
                              {
                                window.customerProfile && window.customerProfile.MobileNumber ?
                                <span className="r-signin myProfile">
                                  <a href="/welcome/logout">Sign Out</a>
                                </span>
                                 :
                                 <span className="r-signin Login_Signup">
                                   <a>Sign In</a>
                                 </span>
                              } 
                            </div>
                            <a href={"tel:"+window.staFooterData.PandCEnquiryno} className="contact theme-btn d-inline-block">
                                <img src={getImgPath("/img/call-icon.png")} alt="" style={{position:'relative',top:'-18px'}}  />
                           </a>
                        </div> 
                        </div>
                </nav>
              </header>
            </div>
        )
    }
}

export default headerSTA
